import { render, staticRenderFns } from "./AccidentsPage.vue?vue&type=template&id=4e77e85c&scoped=true"
import script from "./AccidentsPage.vue?vue&type=script&lang=js"
export * from "./AccidentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77e85c",
  null
  
)

export default component.exports